import { createApp } from "vue";
import App from "./App.vue";
import VueCookies from "vue3-cookies";
import router from "./router";
import { pinia } from "./piniaInstance";
import { ensureSignedIn } from "@/msalConfig";

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(VueCookies);

(async () => {
	try {
		// 1) 初期化〜リダイレクト結果処理〜ActiveAccount 設定を1コールで保証
		await ensureSignedIn();
		// 2) ここでガード登録（遅延 import のままでOK）
		await import("./router/guard.js");
	} catch (error) {
		console.error("MSAL sign-in/init error:", error);
		// 必要ならここでフォールバック（例：エラーページ遷移など）
	} finally {
		// 3) ルーター準備後にマウント（race condition 回避）
		await router.isReady();
		app.mount("#app");
	}
})();
